// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3hGOs","actionsCol":"EnrolledClinics_actionsCol__368E4"};